export const formatDate = function (date) {
  let mes
  let d = new Date(date)
  let m = d.getMonth()

  switch (m) {
    case 0:
      mes = 'Janeiro'
      break
    case 1:
      mes = 'Fevereiro'
      break
    case 2:
      mes = 'Março'
      break
    case 3:
      mes = 'Abril'
      break
    case 4:
      mes = 'Maio'
      break
    case 5:
      mes = 'Junho'
      break
    case 6:
      mes = 'Julho'
      break
    case 7:
      mes = 'Agosto'
      break
    case 8:
      mes = 'Setembro'
      break
    case 9:
      mes = 'Outubro'
      break
    case 10:
      mes = 'Novembro'
      break
    case 11:
      mes = 'Dezembro'
      break
  }

  var date2 = date.split(/\D/)
  let day = new Date(Date.UTC(date2[0], --date2[1], date2[2], date2[3] || 0, date2[4] || 0, date2[5] || 0, date2[6] || 0))

  return day.getDate() + ' de ' + mes + ' de ' + d.getFullYear()
}



// WEBPACK FOOTER //
// ./src/components/common/jm-date.js